<template>
    <div class="home">
        <Topbar />
        <div class="container-fluid text-left" style="margin-top: 50px; justify-content: center;">
            <!-- Content Row -->
            <div class="card shadow col-md-6 m-auto p-0">
                <div class="card-header pt-1 pb-1" :style="{ backgroundColor: moduloAtual().color }">
                    <h6 class="m-0 font-weight-bold text-white">
                        <div>
                            {{ title.text }}: Selecione a lista
                            <div v-show="carregando" class="spinner-grow">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </h6>
                </div>
                <fieldset :disabled="carregando">
                    <div class="card-body bg-light text-primary-dark p-2">
                        <div>
                            <div class="text-center">
                                <div style="display: flex;">
                                    <div class="col p-0">
                                        <InputDefaultApp
                                            inputPlaceHolderSufixo="Digite a lista aqui"
                                            titleScan="Escanear lista"
                                            typeInputMode="numeric"
                                            @displayScanFunction="okConfimarLista"
                                            :enterKey="(e) => dialogoAtribuirLista(e.target.value)"
                                            idInput="pesquisa"
                                            :errorMessage="errors.pesquisa ? errors.pesquisa[0] : ''"
                                        >
                                        </InputDefaultApp>
                                    </div>
                                </div>
                            </div>

                            <div class="collapse" id="filtrocardImportacao">
                                <div class="card card-body bg-light">
                                    <div class="row">
                                        <div class="custom-file form-group col-md-5 ml-2 mt-2">
                                            <input type="hidden" name="arquivo" id="arquivo" v-model="arquivoNome" />
                                            <input
                                                type="file"
                                                class="custom-file-input"
                                                name="files[]"
                                                @change="handleEscolhaArquivo"
                                                id="userfile"
                                                multiple
                                            />
                                            <label
                                                class="custom-file-label"
                                                for="userfile"
                                                data-browse="Buscar"
                                                id="etiqueta"
                                            >
                                                {{ arquivoLabel }}</label
                                            >
                                        </div>
                                        <button
                                            type="submit"
                                            id="btn_save"
                                            name="btn_save"
                                            value="UPLOAD"
                                            class="btn btn-success ml-2 mt-2"
                                            @click="importarPlanilha"
                                            :disabled="arquivos == null"
                                        >
                                            Importar
                                        </button>
                                    </div>
                                </div>
                            </div>

                            
                            <div class="card">

                                <div class="card-body p-2">
                                    <ul class="nav nav-tabs" id="myTab">
                                        <li class="nav-item small">
                                            <a class="nav-link small active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab">PICKING</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link small" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab">MINHAS LISTAS</a>
                                        </li>
                                    </ul>
                                    <div class="tab-content mt-3" id="myTabContent">
                                        <div class="tab-pane fade show active" id="tab1" role="tabpanel">
                                            
                                            <div class="w-100 table-responsive small" style="height: 240px; overflow-y: auto; overflow-x: hidden;">
                                                <table class="table table-sm table-striped table-bordered table-hover">
                                                    <thead class="d-none">
                                                        <tr style="white-space: nowrap">
                                                            <th></th>
                                                            <TableHeader db="nome" label="Tabela" />
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            v-for="line in dados"
                                                            :key="line[idname]"
                                                            :style="{
                                                                backgroundColor: '#' + line.statusbackground,
                                                                color: '#' + line.statuscolor,
                                                            }"
                                                        >
                                                            <td class="small">
                                                                <div class="container-fluid">
                                                                    <div class="row">
                                                                        <div class="col-5 p-0" @click="() => confimarLista(line)">
                                                                            <span class="text-left text-primary">{{
                                                                                line.fantasia
                                                                            }}</span>
                                                                            <br>
                                                                            <span class="text-right text-secondary">{{
                                                                                dateFormat(line.dataemissao)
                                                                            }}</span>
                                                                        </div>
                                                                        <div class="col-5 p-0 text-right" @click="() => confimarLista(line)">
                                                                            <span class="text-left">{{ line.idlistaseparacao }}</span>
                                                                            <br>
                                                                            <span class="text-right text-secondary">{{
                                                                                line.usuario_picking === null ? "NÃO ATRIBUIDA" : line.usuario_picking
                                                                            }}</span>
                                                                        </div>
                                                                        <div class="col-2 text-right pt-2">
                                                                            <em class="fa fa-align-justify" data-toggle="collapse" :data-target="'#list_'+line.idlistaseparacao"></em>
                                                                        </div>
                                                                        <div class="col-12 mt-2 p-0">
                                                                            <div class="collapse border p-1 bg-white" :id="'list_'+line.idlistaseparacao">
                                                                                <span class="font-weight-bold">Lista:</span>
                                                                                <span class="ml-2">{{ line.idlistaseparacao }}</span>
                                                                                <br>
                                                                                <span class="font-weight-bold">Cliente:</span>
                                                                                <span class="ml-2">{{ line.fantasia }} - {{ line.idclientes }}</span>
                                                                                <br>
                                                                                <span class="font-weight-bold">Gerado por:</span>
                                                                                <span class="ml-2">{{ line.nome + " " + dateFormat(line.datagravacao) }}</span>
                                                                                <br>
                                                                                <span class="font-weight-bold">Picking por:</span>
                                                                                <span class="ml-2">{{  line.usuario_picking === null ? "NÃO ATRIBUIDA" : line.usuario_picking + " " + dateFormat(line.emissao) }}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                            
                                                                </div>
                                                                
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="tab2" role="tabpanel">
                                            <div class="w-100 table-responsive small" style="height: 240px; overflow-y: auto; overflow-x: hidden;">
                                                <table class="table table-sm table-striped table-bordered table-hover">
                                                    <thead class="d-none">
                                                        <tr style="white-space: nowrap">
                                                            <th></th>
                                                            <TableHeader db="nome" label="Tabela" />
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            v-for="line in minhaslistas"
                                                            :key="line[idname]"
                                                            :style="{
                                                                backgroundColor: '#' + line.statusbackground,
                                                                color: '#' + line.statuscolor,
                                                            }"
                                                        >
                                                            <td class="small">
                                                                <div class="container-fluid">
                                                                    <div class="row">
                                                                        <div class="col-5 p-0" @click="() => confimarLista(line)">
                                                                            <span class="text-left text-primary">{{
                                                                                line.fantasia
                                                                            }}</span>
                                                                            <br>
                                                                            <span class="text-right text-secondary">{{
                                                                                dateFormat(line.dataemissao)
                                                                            }}</span>
                                                                        </div>
                                                                        <div class="col-5 p-0 text-right" @click="() => confimarLista(line)">
                                                                            <span class="text-left">{{ line.idlistaseparacao }}</span>
                                                                            <br>
                                                                            <span class="text-right text-secondary">{{
                                                                                line.usuario_picking === null ? "NÃO ATRIBUIDA" : line.usuario_picking
                                                                            }}</span>
                                                                        </div>
                                                                        <div class="col-2 text-right pt-2">
                                                                            <em class="fa fa-align-justify" data-toggle="collapse" :data-target="'#my_list_'+line.idlistaseparacao"></em>
                                                                        </div>
                                                                        <div class="col-12 mt-2 p-0">
                                                                            <div class="collapse border p-1 bg-white" :id="'my_list_'+line.idlistaseparacao">
                                                                                <span class="font-weight-bold">Lista:</span>
                                                                                <span class="ml-2">{{ line.idlistaseparacao }}</span>
                                                                                <br>
                                                                                <span class="font-weight-bold">Cliente:</span>
                                                                                <span class="ml-2">{{ line.fantasia }}</span>
                                                                                <br>
                                                                                <span class="font-weight-bold">Gerado por:</span>
                                                                                <span class="ml-2">{{ line.nome + " " + dateFormat(line.emissao) }}</span>
                                                                                <br>
                                                                                <span class="font-weight-bold">Picking por:</span>
                                                                                <span class="ml-2">{{  line.usuario_picking === null ? "NÃO ATRIBUIDA" : line.usuario_picking + " " + dateFormat(line.datagravacao) }}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                            
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <ForbiddenModal />
        <LogoutModal />
        <FooterBar />
        <Modal
            v-if="lista"
            id="confirmarLista"
            title="Confirmar Lista"
            :confirmFunction="() => dialogoAtribuirLista()"
            :carregando="carregando"
        >
            Confirma o início da separação da lista <br/> {{ lista.idlistaseparacao }} - {{ lista.fantasia }}?
        </Modal>
        <Modal
            v-if="lista"
            id="atribuirListaModal"
            title="Atribuir Lista"
            :confirmFunction="() => okAtribuirLista()"
            :carregando="carregando"
            confirmText="Sim"
            cancelText="Não"
        >
        <span v-if="this.lista.usuario_picking">
            Esta lista já está atribuída ao usuário {{ this.lista.usuario_picking }}. Deseja reatribuir para você?
        </span>
        <span v-if="!this.lista.usuario_picking">
            Esta lista está disponível para atribuição. Deseja vinculá-la ao seu usuário?
        </span>
        </Modal>
        <Modal
            id="scanModal"
            title="Escanear"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="fecharScan"
        >
            <StreamBarcodeReader v-if="scanAberto" @decode="onDecode" @loaded="onLoaded" @error="onError"></StreamBarcodeReader>
        </Modal>
    </div>
</template>

<script>
// @ is an alias to /src
import Topbar from "@/components/Topbar.vue";
import LogoutModal from "@/components/LogoutModal.vue";
import TableHeader from "@/components/TableHeader.vue";
import ViewMixin from "./ViewMixin";
import api, { getUserId, getUsername } from "../services/api";
import $ from "jquery";
import {
    ClientErrorException,
    DEFAULT_ERROR_MESSAGE,
    EnderecoDiferenteException,
    ListaConcluidaException,
    PermissaoException,
    ServerErrorException,
    TokenInvalidoException,
    ValidationException,
} from "../services/exceptions";
import { enterKey, dateFormat, selecionar, scrollToTop } from "../utils";
import ForbiddenModal from "../components/ForbiddenModal.vue";
import Modal from "../components/Modal.vue";
import InputDefaultApp from "../components/InputDefaultApp.vue";
import Audio from "../services/audioService";
import FooterBar from '@/components/FooterBar.vue'

export default {
    name: "Picking",
    mixins: [ViewMixin],
    components: {
        Topbar,
        LogoutModal,
        TableHeader,
        ForbiddenModal,
        InputDefaultApp,
        Modal,
        FooterBar,
    },
    data: () => {
        return {
            idname: "idlista",
            minhaslistas: [],
            baseUrl: "picking",
            title: {
                icon: "fas fa-cash-register",
                text: "Picking",
            },
            sort: "nome",
            sortDirection: "asc",
            filtro: {
                pesquisa: "",
            },
            arquivoLabel: "Selecionar Arquivo",
            arquivoNome: "",
            arquivos: null,
            lista: null,
            scanAberto: false,
        };
    },
    mounted() {
        this.list();
        this.myList();
    },
    methods: {
        enterKey,
        dateFormat,

        handleEscolhaArquivo(e) {
            if (e.target.files.length > 0) {
                this.arquivoLabel = "";
                for (const element of e.target.files) {
                    const file = element;
                    this.arquivoLabel += '"' + file.name + '" ';
                }
                this.arquivoNome = e.target.files[0].name;
                this.arquivos = e.target.files;
            } else {
                this.arquivoLabel = "Selecionar Arquivo";
                this.arquivos = null;
            }
        },

        async getCombos() {
            this.carregando = true;

            try {
                let { baseUrl } = this;
                let response = await api.get(`/${baseUrl}/combos`);

                this.combos = response.data;
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }

            this.carregando = false;
        },

        async list() {
            this.carregando = true;

            try {

                let { baseUrl, sort, sortDirection, filtro, perPage, pular } = this;
                let response = await api.get(`/${baseUrl}/`, {
                    params: {
                        sort: `${sort} ${sortDirection}`,
                        ...filtro,
                        perPage,
                        pular,
                    },
                });

                this.dados = response.data.listas;

                setTimeout(() => {
                    selecionar('#pesquisa')
                }, 100);
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }

            this.carregando = false;
        },

        async myList() {
            this.carregando = true;

            try {

                let { baseUrl, sort, sortDirection, filtro, perPage, pular } = this;
                let response = await api.get(`/${baseUrl}/${getUserId()}`, {
                    params: {
                        sort: `${sort} ${sortDirection}`,
                        ...filtro,
                        perPage,
                        pular,
                    },
                });

                this.minhaslistas = response.data.listas;

                setTimeout(() => {
                    selecionar('#pesquisa')
                }, 100);
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }

            this.carregando = false;
        },

        async importarPlanilha() {
            this.carregando = true;

            try {
                $("#filtrocardImportacao").collapse("hide");

                let { baseUrl, arquivos } = this;
                const formData = new FormData();
                for (let i = 0; i < arquivos.length; i++) {
                    formData.append(`files[${i}]`, arquivos[i]);
                }

                await api.post(`/${baseUrl}/importar`, formData, {
                    headers: { "content-type": "multipart/form-data" },
                });

                this.dados = [];
                this.list();
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                    console.error(e);
                }
            }

            this.carregando = false;
        },

        async exportar() {
            try {
                const response = await this.apiExport();
                const today = new Date().toISOString().slice(0, 10);
                const fileName = `${this.title.text}_${today}.csv`;
                const blobURL = URL.createObjectURL(new File([response.data], fileName));
                const a = document.createElement("a");
                a.href = blobURL;
                a.style = "display: none";
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
            } catch (e) {
                console.error(e);
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }
            this.carregando = false;
        },

        async apiExport() {
            this.carregando = true;

            let { pular, perPage } = this;

            const response = await api.get(`/${this.baseUrl}/exportar`, {
                responseType: "blob",
                params: {
                    pular,
                    perPage,
                    sort: `${this.sort} ${this.sortDirection}`,
                    ...this.filtro,
                },
            });

            this.carregando = false;

            return response;
        },

        confimarLista(lista) {
            this.lista = lista;
            setTimeout(() => {
                $("#confirmarLista").modal("show");
            }, 100);
        },

        async dialogoAtribuirLista(idlista = null) {
            
            if (idlista !== null) {
                for (const item of this.dados) {
                    if (item.idlistaseparacao == idlista) {
                        this.lista = item;
                        break;
                    }
                }
            } else {
                $("#confirmarLista").modal("hide");
            }

            if (this.lista.usuario_picking !== getUsername()) {
                setTimeout(() => {
                    $("#atribuirListaModal").modal("show");
                }, 250);
            } else {
                this.okConfimarLista();
            }
        },

        async okConfimarLista(idlista = null) {
            scrollToTop();
            $("#confirmarLista").modal("hide");
            let tocarSucesso = true;
            if (idlista === null) {
                idlista = this.lista.idlistaseparacao
                tocarSucesso = false
            }
            if (await this.verificarLista(idlista, tocarSucesso)) {
                this.$router.push('picking/enderecos/' + idlista)
            }
        },

        async okAtribuirLista() {
            try {
                let response = await api.post('/picking/atribuirusuario', {
                    idLista: this.lista.idlistaseparacao,
                    idUsuario: getUserId()
                });

                if (response.data.success) {
                    this.okConfimarLista();
                } else {
                    alert("Lista não atribuida ao seu usuário! Tente novamente mais tarde!");
                }

            } catch (e) {
                console.error(e);
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }
        },

        abrirScan() {
            this.scanAberto = true;
            $("#scanModal").modal("show");
        },
        fecharScan() {
            this.scanAberto = false;
            $("#scanModal").modal("hide");
        },
        onDecode(r) {
            this.okConfimarLista(r)
            this.fecharScan();
        },
        onError(r) {
            console.log(r)
            alert("Não foi possível escanear")
        },
        onLoaded() {
            console.log("Scan")
        },

        async verificarLista(idlista, tocarSucesso) {
            this.carregando = true;

            try {

                let { baseUrl, sort, sortDirection, filtro, perPage, pular } = this;
                await api.get(`/${baseUrl}/enderecos/${idlista}`, {
                    params: {
                        sort: `${sort} ${sortDirection}`,
                        ...filtro,
                        perPage,
                        pular,
                    },
                });

                this.carregando = false;
                if (tocarSucesso) {
                    // Audio.success()
                }
                return true
            } catch (e) {
                this.exception = e;
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ListaConcluidaException) {
                    this.message = e.message;
                    $("#warningModal").modal("show");
                    setTimeout(() => {
                        this.carregando = false;
                    }, 100);
                } else if (e instanceof EnderecoDiferenteException) {
                    this.$router.push('/picking/enderecos/' + this.id)
                } else if (e instanceof ClientErrorException) {
                    this.message = e.message;
                    this.errors.pesquisa = [e.message];
                    Audio.ops()
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
                setTimeout(() => {
                    selecionar('#pesquisa')
                }, 100);
                console.error(e);
            }

            this.carregando = false;
            return false
        },
    },
};
</script>

<style scoped lang="scss">
.spinner-grow {
    width: 1em;
    height: 1em;
}

</style>
